document.addEventListener("DOMContentLoaded", function () {
  const modal = document.querySelector(".hc-modal");
  const openButton = document.querySelector(".hc-open-quiz");
  const closeButtons = document.querySelectorAll("[data-hc-close]");
  const steps = document.querySelectorAll(".hc-step");
  const progress = document.querySelector(".hc-progress");
  const progressBar = document.querySelector(".hc-progress-bar");
  const result = document.querySelector(".hc-result");
  const resultTitle = document.querySelector(".hc-result-title");
  const resultText = document.querySelector(".hc-result-text");
  const productsContainer = document.querySelector(".hc-products");
  const stepBackButton = document.querySelector(".hc-step-back");
  const resultBackButton = document.querySelector(".hc-result-back");
  const restartButton = document.querySelector(".hc-restart-button");

  let cartMessage = document.querySelector(".hc-cart-message");
  let currentStep = 1;
  let currentMainProductKey = null;
  let quizMode = "normal";

  const answers = {
    hair: null,
    look: null,
    finish: null,
    daily: null
  };

  const products = {
    mattePaste: {
      title: "Matte Paste",
      displayTitle: "Matte Paste",
      url: "/products/matte-paste-noble-cut",
      variantId: 53242558742861,
      fileImage: "/cdn/shop/files/pasteklein.png",
      shortText: "Volumen, Textur und ein extrem mattes Finish."
    },
    heavyClay: {
      title: "Heavy Clay",
      displayTitle: "Heavy Clay",
      url: "/products/heavy-clay-noble-cut",
      variantId: 53242551009613,
      fileImage: "/cdn/shop/files/heavyclayklein.png",
      shortText: "Starker Halt, Struktur und Kontrolle."
    },
    pomade: {
      title: "Signature Pomade",
      displayTitle: "Signature Pomade",
      url: "/products/signature-pomade-noble-cut",
      variantId: 53242545013069,
      fileImage: "/cdn/shop/files/pomadeklein.png",
      shortText: "Eleganter Glanz, Definition und gepflegte Form."
    },
    seaSaltSpray: {
      title: "Sea Salt Spray",
      displayTitle: "Sea Salt Spray",
      url: "/products/sea-salt-spray-pre-styler",
      variantId: 53242567491917,
      fileImage: "/cdn/shop/files/seasaltklein.png",
      shortText: "Volumen, Griffigkeit und die perfekte Styling-Basis."
    }
  };

  const scoringRules = {
    hair_fine: { mattePaste: 8, pomade: 1 },
    hair_normal: { mattePaste: 2, heavyClay: 2, pomade: 2 },
    hair_thick: { heavyClay: 8, pomade: 5 },
    look_natural: { mattePaste: 4 },
    look_elegant: { pomade: 5 },
    look_volume: { mattePaste: 3, heavyClay: 3 },
    finish_natural_matte: { mattePaste: 3, heavyClay: 2 },
    finish_ultra_matte: { heavyClay: 5, mattePaste: 3 },
    finish_shine: { pomade: 999 },
    daily_easy: { mattePaste: 5 },
    daily_controlled: { heavyClay: 6 },
    daily_formal: { pomade: 6 }
  };

  const resultCopy = {
    mattePaste: {
      title: "NATURAL TEXTURE LOOK",
      subtitle: "Locker. Matt. Mühelos gut.",
      text: "Deine Routine für natürliche Textur, mehr Volumen und ein modernes mattes Finish.",
      normalTitle: "Sea Salt Spray + Matte Paste"
    },
    heavyClay: {
      title: "STRONG MATTE LOOK",
      subtitle: "Starker Halt. Mattes Finish. Null Kompromisse.",
      text: "Deine Routine für Kontrolle, Struktur und einen Look, der den ganzen Tag in Form bleibt.",
      normalTitle: "Sea Salt Spray + Heavy Clay"
    },
    pomade: {
      title: "CLEAN BUSINESS LOOK",
      subtitle: "Gepflegt. Kontrolliert. Souverän.",
      text: "Deine Routine für Side Part, Slick Back und elegante Looks mit kontrolliertem Glanz.",
      normalTitle: "Sea Salt Spray + Signature Pomade"
    }
  };

  if (!modal || !openButton || !result || !productsContainer) return;

  removeOldButtons();
  ensureCartMessage();

  openButton.addEventListener("click", function () {
    quizMode = "normal";
    openQuiz();
  });

  document.querySelectorAll('a[href="#hair-quiz"]').forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      quizMode = "normal";
      openQuiz();
    });
  });

  document.querySelectorAll('a[href="#hair-quiz-routine"]').forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      quizMode = "routine";
      openQuiz();
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener("click", closeQuiz);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && modal.classList.contains("is-open")) {
      closeQuiz();
    }
  });

  document.querySelectorAll(".hc-option").forEach(function (button) {
    button.addEventListener("click", function () {
      const step = button.closest(".hc-step");
      if (!step) return;

      const question = step.dataset.question;
      const value = button.dataset.value;

      answers[question] = value;

      step.querySelectorAll(".hc-option").forEach(function (option) {
        option.classList.toggle("is-selected", option === button);
      });

      if (currentStep < 4) {
        goToStep(currentStep + 1);
      } else {
        showResults();
      }
    });
  });

  if (stepBackButton) {
    stepBackButton.addEventListener("click", function () {
      if (currentStep > 1) goToStep(currentStep - 1);
    });
  }

  if (resultBackButton) {
    resultBackButton.addEventListener("click", function () {
      result.classList.remove("is-visible");
      modal.classList.remove("hc-result-mode");
      if (progress) progress.style.display = "block";
      goToStep(4);
    });
  }

  if (restartButton) {
    restartButton.addEventListener("click", restartQuiz);
  }

  productsContainer.addEventListener("click", function (event) {
    const viewButton = event.target.closest("[data-hc-view-product]");

    if (viewButton) {
      const productKey = viewButton.dataset.hcViewProduct;
      const product = products[productKey];

      if (product && product.url) {
        window.location.href = product.url;
      }

      return;
    }

    const addButton = event.target.closest("[data-hc-add-products]");

    if (addButton) {
      const productKeys = addButton.dataset.hcAddProducts
        .split(",")
        .map(function (key) { return key.trim(); })
        .filter(Boolean);

      addProductsToCart(productKeys, addButton);
      return;
    }

    const restart = event.target.closest("[data-hc-restart]");
    if (restart) restartQuiz();
  });

  function openQuiz() {
    resetQuizState();

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeQuiz() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    modal.classList.remove("hc-result-mode");
    document.body.style.overflow = "";
  }

  function resetQuizState() {
    answers.hair = null;
    answers.look = null;
    answers.finish = null;
    answers.daily = null;

    currentStep = 1;
    currentMainProductKey = null;

    document.querySelectorAll(".hc-option").forEach(function (option) {
      option.classList.remove("is-selected");
    });

    result.classList.remove("is-visible");
    modal.classList.remove("hc-result-mode");
    productsContainer.innerHTML = "";

    if (resultTitle) resultTitle.textContent = "";
    if (resultText) resultText.textContent = "";

    if (progress) progress.style.display = "block";
    if (progressBar) progressBar.style.width = "25%";
    if (stepBackButton) stepBackButton.classList.remove("is-visible");

    steps.forEach(function (step) {
      const isFirst = Number(step.dataset.step) === 1;
      step.classList.toggle("active", isFirst);
      step.style.display = isFirst ? "block" : "none";
    });
  }

  function goToStep(stepNumber) {
    currentStep = stepNumber;
    result.classList.remove("is-visible");

    steps.forEach(function (step) {
      const isActive = Number(step.dataset.step) === stepNumber;
      step.classList.toggle("active", isActive);
      step.style.display = isActive ? "block" : "none";
    });

    if (progress) progress.style.display = "block";
    if (progressBar) progressBar.style.width = `${stepNumber * 25}%`;
    if (stepBackButton) stepBackButton.classList.toggle("is-visible", stepNumber > 1);

    restoreSelectedAnswer(stepNumber);
  }

  function restoreSelectedAnswer(stepNumber) {
    const step = document.querySelector(`.hc-step[data-step="${stepNumber}"]`);
    if (!step) return;

    const question = step.dataset.question;
    const savedValue = answers[question];

    step.querySelectorAll(".hc-option").forEach(function (option) {
      option.classList.toggle("is-selected", option.dataset.value === savedValue);
    });
  }

  function showResults() {
    steps.forEach(function (step) {
      step.style.display = "none";
      step.classList.remove("active");
    });

    if (progress) progress.style.display = "none";
    if (stepBackButton) stepBackButton.classList.remove("is-visible");

    const mainProductKey = calculateRecommendation();
    currentMainProductKey = mainProductKey;

    renderRoutineResult(mainProductKey);

    modal.classList.add("hc-result-mode");
    result.classList.add("is-visible");
  }

  function calculateRecommendation() {
    if (answers.finish === "finish_shine") return "pomade";

    const scores = { mattePaste: 0, heavyClay: 0, pomade: 0 };

    Object.values(answers).forEach(function (answer) {
      const rule = scoringRules[answer];
      if (!rule) return;

      Object.keys(rule).forEach(function (productKey) {
        scores[productKey] += rule[productKey];
      });
    });

    return Object.keys(scores).sort(function (a, b) {
      return scores[b] - scores[a];
    })[0];
  }

  function getProductKeysForMode(mainProductKey) {
    if (quizMode === "routine") {
      if (mainProductKey === "mattePaste") return ["mattePaste", "seaSaltSpray", "pomade"];
      if (mainProductKey === "heavyClay") return ["heavyClay", "seaSaltSpray", "pomade"];
      if (mainProductKey === "pomade") return ["pomade", "seaSaltSpray", "heavyClay"];
    }

    return [mainProductKey, "seaSaltSpray"];
  }

  function renderRoutineResult(mainProductKey) {
    const copy = resultCopy[mainProductKey];
    const productKeys = getProductKeysForMode(mainProductKey);
    const isRoutine = productKeys.length === 3;

    if (!copy || !productKeys.length) return;

    if (resultTitle) resultTitle.textContent = "";
    if (resultText) resultText.textContent = "";

    const productCards = productKeys.map(function (key, index) {
      const product = products[key];
      const image = getResultImage(key);

      return `
        <article class="hc-routine-product">
          <div class="hc-routine-number">${index + 1}</div>
          ${image ? `<img src="${image}" alt="${product.title}" class="hc-routine-product-image">` : ""}
          <h4 class="hc-routine-product-title">${product.displayTitle || product.title}</h4>
          <p class="hc-routine-product-text">${product.shortText}</p>
        </article>
      `;
    }).join("");

    const priceLabel = isRoutine ? "Routine Preis" : "Empfehlung";
    const buttonText = isRoutine ? "Routine in den Warenkorb" : "Empfehlung in den Warenkorb";
    const recommendationTitle = isRoutine ? "GENTLEMAN ROUTINE" : copy.title;
    const recommendationSubtitle = isRoutine ? "Jeden Look meistern. Jeden Tag." : copy.subtitle;
    const recommendationText = isRoutine
      ? "Deine komplette Noble Cut Routine: vorbereitet, kontrolliert und flexibel für Alltag, Business und Abend."
      : copy.text;

    productsContainer.innerHTML = `
      <div class="hc-routine-result">
        <div class="hc-routine-check">✓</div>

        <p class="hc-routine-kicker">${isRoutine ? "Deine empfohlene Routine" : "Deine Empfehlung"}</p>

        <h3 class="hc-routine-title">${recommendationTitle}</h3>

        <p class="hc-routine-copy">${recommendationSubtitle}</p>

        <div class="hc-routine-grid" data-count="${productKeys.length}">
          ${productCards}
        </div>

        <div class="hc-routine-note">
          <div class="hc-routine-note-icon">✓</div>
          <div>
            <div class="hc-routine-note-title">${isRoutine ? "Komplette Routine. Perfekter Look." : "Deine Basis. Dein perfektes Styling."}</div>
            <div class="hc-routine-note-text">${recommendationText}</div>
          </div>
        </div>

        <div class="hc-routine-buybox">
          <div class="hc-routine-price">
            <span class="hc-price-label">${priceLabel}</span>
            <span class="hc-price-value">${isRoutine ? "68,35 €" : "44,94 €"}</span>

            <span class="hc-compare-label">statt</span>
            <span class="hc-compare-value">${isRoutine ? "72,70 €" : "47,80 €"}</span>

            <span class="hc-shipping-benefit">${isRoutine ? "& freier Versand" : "& Versand sparen"}</span>
          </div>

          <button type="button" class="hc-routine-button" data-hc-add-products="${productKeys.join(",")}">
            ${buttonText} →
          </button>

          <button type="button" class="hc-routine-secondary" data-hc-view-product="${mainProductKey}">
            ${products[mainProductKey].displayTitle} ansehen
          </button>

          <button type="button" class="hc-routine-secondary" data-hc-restart>
            Quiz neu starten
          </button>
        </div>

        <div class="hc-routine-benefits">
          <div class="hc-routine-benefit"><span>✓</span> Auf deinen Look abgestimmt</div>
          <div class="hc-routine-benefit"><span>≋</span> Mehr Struktur & Kontrolle</div>
          <div class="hc-routine-benefit"><span>◇</span> Für Alltag, Business & Abend</div>
          <div class="hc-routine-benefit"><span>◷</span> Routine in unter 60 Sekunden</div>
        </div>
      </div>
    `;
  }

  function getRoutinePrice(productKeys) {
    const prices = {
      mattePaste: 23.90,
      heavyClay: 23.90,
      pomade: 24.90,
      seaSaltSpray: 21.90
    };

    const total = productKeys.reduce(function (sum, key) {
      return sum + (prices[key] || 0);
    }, 0);

    return total.toFixed(2).replace(".", ",") + " €";
  }

  function getResultImage(productKey) {
    const dataImages = {
      mattePaste: result.dataset.mattePasteImage || "",
      heavyClay: result.dataset.heavyClayImage || "",
      pomade: result.dataset.pomadeImage || "",
      seaSaltSpray: result.dataset.seaSaltImage || ""
    };

    const fallbackImages = {
      mattePaste: products.mattePaste.fileImage,
      heavyClay: products.heavyClay.fileImage,
      pomade: products.pomade.fileImage,
      seaSaltSpray: products.seaSaltSpray.fileImage
    };

    return dataImages[productKey] || fallbackImages[productKey] || "";
  }

  function restartQuiz() {
    resetQuizState();
  }

  async function addProductsToCart(productKeys, button) {
    const items = productKeys
      .map(function (key) { return products[key]; })
      .filter(function (product) { return product && product.variantId; })
      .map(function (product) {
        return { id: Number(product.variantId), quantity: 1 };
      });

    if (!items.length) {
      showCartMessage("Produkt nicht gefunden.");
      return;
    }

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = "Wird hinzugefügt...";

    try {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";

      const response = await fetch(root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ items: items })
      });

      let data = null;
      try { data = await response.json(); } catch (error) { data = null; }

      if (!response.ok) {
        const message = data && (data.description || data.message) ? data.description || data.message : "Bitte versuche es erneut.";
        throw new Error(message);
      }

      showCartMessage("Erfolgreich hinzugefügt");
      updateCartBubble();
      refreshDawnCart();

      setTimeout(function () {
        window.location.href = "/cart";
      }, 300);
    } catch (error) {
      showCartMessage(error.message || "Bitte versuche es erneut.");
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  async function updateCartBubble() {
    try {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
      const response = await fetch(root + "cart.js");
      if (!response.ok) return;

      const cart = await response.json();
      const bubbles = document.querySelectorAll(".cart-count-bubble span[aria-hidden='true'], .cart-count-bubble span:not(.visually-hidden)");

      bubbles.forEach(function (bubble) {
        bubble.textContent = cart.item_count;
      });

      const cartBubble = document.querySelector(".cart-count-bubble");
      if (cartBubble) cartBubble.style.display = cart.item_count > 0 ? "" : "none";
    } catch (error) {}
  }

  function refreshDawnCart() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";

    fetch(root + "cart.js", {
      method: "GET",
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        if (!cart) return;
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  function showCartMessage(message) {
    if (!cartMessage) return;

    cartMessage.textContent = message;
    cartMessage.classList.add("is-visible");

    window.clearTimeout(showCartMessage.timeoutId);
    showCartMessage.timeoutId = window.setTimeout(function () {
      cartMessage.classList.remove("is-visible");
    }, 4000);
  }

  function ensureCartMessage() {
    if (cartMessage) return;

    cartMessage = document.createElement("div");
    cartMessage.className = "hc-cart-message";
    cartMessage.setAttribute("role", "status");
    cartMessage.setAttribute("aria-live", "polite");
    cartMessage.textContent = "Erfolgreich hinzugefügt";
    document.body.appendChild(cartMessage);
  }

  function removeOldButtons() {
    document.querySelectorAll(".hc-duo-cart-button, .hc-main-product-button").forEach(function (button) {
      button.remove();
    });
  }
});
